import { storagePrefix } from "./config";
const key = `${storagePrefix}entryIntent`;
type Intent = { key: string; ready: boolean };
let memory: Intent | null = null;
function read(): Intent | null {
  try {
    return JSON.parse(sessionStorage.getItem(key) || "null");
  } catch {
    return memory;
  }
}
function write(value: Intent | null) {
  memory = value;
  try {
    if (value) sessionStorage.setItem(key, JSON.stringify(value));
    else sessionStorage.removeItem(key);
  } catch {
    /* Per-tab memory fallback. */
  }
}
export function requestEntry(accessKey: string) {
  write({ key: accessKey, ready: false });
}
export function clearEntryIntent() {
  write(null);
}
export function entryDestination(fallback: string, ready = false) {
  const intent = read();
  if (!intent) return fallback;
  if (ready) write({ ...intent, ready: true });
  return `/in/${encodeURIComponent(intent.key)}`;
}
export function consumeEntry(accessKey: string) {
  const intent = read();
  if (!intent?.ready || intent.key !== accessKey) return false;
  write(null);
  return true;
}
export function cancelEntryOutside(path: string) {
  const intent = read();
  if (
    intent &&
    ![
      "/login",
      "/phone-authentication",
      "/code-authentication",
      "/onboarding",
      "/onboarding/additional-data",
      "/onboarding/avatar-selection",
      `/in/${intent.key}`,
    ].includes(path)
  )
    clearEntryIntent();
}
